import React from 'react';
import { Image, View } from 'react-native';
import FullPageSimulator from '../../FullPageSimulator';
import CurrencyAmountLine from '../../../AuxiliaryComponent/AmountSim/CurrencyAmountLine';
import InputTextOverBtn from '../../../AuxiliaryComponent/MixComponent/InputTextOverBtn';
import TopImageBar from '../../../AuxiliaryComponent/Images/TopImageBar';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { img_tree_with_sky, img_x } from '../../../../../utils/ImagesManagementUtils';
import { Rent_str } from '../../../../../utils/DictionaryManagementUtils';

//= ========================================================================
const ReferenceMainScreenFP = ({
  globJSON,
  simPlatform,
  selectOptions,
  subCategoryId,
  TopTitle,
  WithGrayBackground,
  withSubCategory,
  slideshowRefs,
  withPrimaryColor,
  withAddPhoto,
  showOneBigImage,
  inputText,
  paymentReason,
}) => {
  const { reference } = globJSON.configurations.services[subCategoryId];
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    bigImageStyle: {
      width: 142,
      height: 142,
      alignSelf: 'center',
      marginBottom: selectOptions ? 10 : 6,
    },
    imgX: {
      width: 16,
      height: 16,
      tintColor: 'white',
      position: 'absolute',
      borderWidth: 1,
      borderColor: 'white',
      borderRadius: 8,
      right: 57,
      marginTop: 7,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={paymentReason ? reference.payment_reason : reference.add_a_reference}
      TopTitle={TopTitle}
      WithGrayBackground={WithGrayBackground}
      slideshowRefs={slideshowRefs}
    >
      {withAddPhoto && !showOneBigImage && <TopImageBar marginBottom={20} />}
      {withAddPhoto && showOneBigImage
                    && (
                      <View>
                        <Image
                          fadeDuration={0}
                          style={myStyles.bigImageStyle}
                          source={img_tree_with_sky}
                        />
                        <Image
                          fadeDuration={0}
                          style={myStyles.imgX}
                          source={img_x}
                        />
                      </View>
                    )}
      {selectOptions ? (
        <View style={{ borderTopWidth: 1, borderColor: colors.border_color }}>
          <CurrencyAmountLine
            globJSON={globJSON}
            currencyStr={showOneBigImage ? Rent_str : reference.select_payment_reason}
            withIconPointRight
            simPlatform={simPlatform}
          />
          <LargeBtnWithFilling
            marginTop={14}
            globJSON={globJSON}
            simPlatform={simPlatform}
            inputText={reference.next}
          />
        </View>
      ) : (
        <View>
          {showOneBigImage ? (
            <InputTextOverBtn
              globJSON={globJSON}
              inputText={inputText}
              subCategoryId={subCategoryId}
              simPlatform={simPlatform}
              whiteBackground
              withSubCategory={withSubCategory}
              withPrimaryColor={withPrimaryColor}
              marginTop={14}
            />
          ) : (
            <InputTextOverBtn
              globJSON={globJSON}
              inputText={reference.enter_free_text}
              subCategoryId={subCategoryId}
              simPlatform={simPlatform}
              withPrimaryColor={withPrimaryColor}
              marginTop={14}
            />
          )}
        </View>
      )}
    </FullPageSimulator>
  );
};
export default ReferenceMainScreenFP;
